module.exports = __webpack_public_path__ + "static/media/groguru-long-logo@3x.5e621795.png";